import {NumberFormatOptions, NumberFormatter} from '@internationalized/number';
import {useMemo} from 'react';

export function useNumberFormatter(
  options: NumberFormatOptions = {}
): Intl.NumberFormat {
  const locale = 'en-US'; 
  return useMemo(() => new NumberFormatter(locale, options), [locale, options]);
}
